import { API } from '../index';

// Carousel Management
export const getCarouselById = async (id: string) => {
  return API.get(`/sites/carousel/${id}/`);
};

export const updateCarouselImage = async (key: string, display_level: number, carouselId: string, url: string) => {
  return API.put(`/sites/carousel-image-admin/${key}/`, {
    display_level: display_level ? display_level : undefined,
    carousel: carouselId,
    url: url ? url : undefined
  });
};

export const deleteCarouselImage = async (key: string) => {
  return API.delete(`/sites/carousel-image-admin/${key}/`);
};

export const uploadCarouselImage = async (formData: FormData) => {
  return API.post('/sites/carousel-image-admin/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const updateCarouselOrder = async (carousels: any) => {
  return API.put('/sites/carousels/update-order/', carousels);
};

export const addCarousel = async (images: string[]) => {
  return API.post('/sites/carousels/', { images });
};

export const deleteCarousel = async (id: string) => {
  return API.delete(`/sites/carousels/${id}/`);
};